import React, {useState, useEffect } from "react";
import { Nav } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import { getToken, getUser } from "../utils/Common";
import logo from "../assets/images/sova_orange_login.png";
import { Badge } from 'primereact/badge';

export const withRouter = (Component) => {
  const Wrapper = (props) => {
    const history = useNavigate();

    return <Component history={history} {...props} />;
  };

  return Wrapper;
};




const Side = (props) => {
  let navigate = useNavigate();
  const [neprocitanePoruke, setNeprocitanePoruke] = useState([]);

  useEffect(() => {
    if ( sessionStorage.getItem("ustanova") !== null && sessionStorage.getItem("ustanova") === "pouz.hr") {
      fetch(
        props.rest +
          sessionStorage.getItem("ustanova") +
          "&prema_obliku=" +
          sessionStorage.getItem("premaObliku") +
          "&godina_upisa=" +
          sessionStorage.getItem("godinaUpisa") +
          "&redni_broj=" +
          sessionStorage.getItem("redniBroj"),
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: sessionStorage.getItem("token"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return null;
        }
      })
      .then((data) => {
        setNeprocitanePoruke([]);
        data.forEach( poruka => {
          if (poruka.posiljatelj_je_polaznik !== true && poruka.vrijeme_citanja === null) {
            setNeprocitanePoruke(neprocitanePoruke => [...neprocitanePoruke, poruka]);
          }
        })
      })
      .catch((err) => {
      });
    }
  }, [navigate, props.rest]);


  return (
    <>
      { getUser() != null && getToken != null ? (
        <Nav className="sidebar-wrapper">
          <div className="sidebar-img">
            <img
              src={logo}
              alt="Logo"
              height={35}
              onClick={() => {
                navigate("/");
              }}
            />
          </div>
          <div className="sidebar-bar-menu">
            <div className="sidebar-bar-linkwrapper">
              <p>I Z B O R N I K</p>
              <Nav.Item className="sidebar-menuitem">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive ? "sidebar-active-link" : "sidebar-inactive-link"
                  }
                >
                  <i className="pi pi-home" />
                  Početna{" "}
                </NavLink>
              </Nav.Item>
              <Nav.Item className="sidebar-menuitem">
                <NavLink
                  to="/ocjene"
                  className={({ isActive }) =>
                    isActive ? "sidebar-active-link" : "sidebar-inactive-link"
                  }
                >
                  <i className="pi pi-list" />
                  Ocjene{" "}
                </NavLink>
              </Nav.Item>
              <Nav.Item className="sidebar-menuitem">
                  <NavLink 
                    to="/zavrsneOcjene"
                  className={({ isActive }) =>
                    isActive ? "sidebar-active-link" : "sidebar-inactive-link"
                  }
                  >
                  <i className="pi pi-list" />
                    Zavrsne ocjene{" "}
                  </NavLink>                  
              </Nav.Item>
              <Nav.Item className="sidebar-menuitem">
                <NavLink to="/ispiti" className={({ isActive }) =>
                    isActive ? "sidebar-active-link" : "sidebar-inactive-link"
                  }>
                  <i className="pi pi-check-square" />
                  Ispiti{" "}
                </NavLink>
              </Nav.Item>
              <Nav.Item className="sidebar-menuitem">
                <NavLink to="/biljeske" className={({ isActive }) =>
                    isActive ? "sidebar-active-link" : "sidebar-inactive-link"
                  }>
                  <i className="pi pi-pencil" />
                  Bilješke{" "}
                </NavLink>
              </Nav.Item>
              <Nav.Item className="sidebar-menuitem">
                <NavLink to="/izostanci" className={({ isActive }) =>
                    isActive ? "sidebar-active-link" : "sidebar-inactive-link"
                  }>
                  <i className="pi pi-calendar-times" />
                  Izostanci{" "}
                </NavLink>
              </Nav.Item>
              <Nav.Item className="sidebar-menuitem">
                <NavLink to="/raspored" className={({ isActive }) =>
                    isActive ? "sidebar-active-link" : "sidebar-inactive-link"
                  }>
                  <i className="pi pi-calendar" />
                  Raspored{" "}
                </NavLink>
              </Nav.Item>
              {/*sessionStorage.getItem("ustanova") != null && ( sessionStorage.getItem("ustanova") === "pouz.hr" || sessionStorage.getItem("ustanova") === "test.hr" ) ? 
                  (<>
                    <Nav.Item className="sidebar-menuitem">
                      <NavLink to="/nastavni_materijali" className={({ isActive }) =>
                          isActive ? "sidebar-active-link" : "sidebar-inactive-link"
                        }>
                        <i className="pi pi-folder-open" />
                        Nastavni materijali{" "}
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item className="sidebar-menuitem">
                      <NavLink to="/poruke" className={({ isActive }) =>
                          isActive ? "sidebar-active-link" : "sidebar-inactive-link"
                        }>
                        <i className="pi pi-comments"/>
                        Poruke{" "}{neprocitanePoruke.length > 0 ? <Badge value={neprocitanePoruke.length}></Badge> : ""}
                      </NavLink>
                    </Nav.Item>
                  </>) 
                : 
                      (<></>)*/ }
                <Nav.Item className="sidebar-menuitem">
                <NavLink to="/logout" className={({ isActive }) =>
                    isActive ? "sidebar-active-link" : "sidebar-inactive-link"
                  }>
                  <i className="pi pi-sign-out" />
                  Odjava{" "}
                </NavLink>
              </Nav.Item>
            </div>
          </div>
        </Nav>
      ) : (
        <></>
      )}
    </>
  );
};

const Sidebar = withRouter(Side);
export default Sidebar;
